var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToasterCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16937 15.5804C8.97937 15.5804 8.78938 15.5104 8.63938 15.3604C8.34938 15.0704 8.34938 14.5904 8.63938 14.3004L14.2994 8.64035C14.5894 8.35035 15.0694 8.35035 15.3594 8.64035C15.6494 8.93035 15.6494 9.41035 15.3594 9.70035L9.69937 15.3604C9.55937 15.5104 9.35937 15.5804 9.16937 15.5804Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8294 15.5804C14.6394 15.5804 14.4494 15.5104 14.2994 15.3604L8.63938 9.70035C8.34938 9.41035 8.34938 8.93035 8.63938 8.64035C8.92937 8.35035 9.40937 8.35035 9.69937 8.64035L15.3594 14.3004C15.6494 14.5904 15.6494 15.0704 15.3594 15.3604C15.2094 15.5104 15.0194 15.5804 14.8294 15.5804Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterCloseIcon);
export default __webpack_public_path__ + "static/media/toaster-close-icon.1384bbd330d747dbe183e78e134119a9.svg";
export { ForwardRef as ReactComponent };